/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PersonTypeEnum {
    PERSON = 'PERSON',
    PLAYER = 'PLAYER',
    REFEREE = 'REFEREE',
    COACH = 'COACH',
}
